import { render, staticRenderFns } from "./re-spinner.vue?vue&type=template&id=08b41ad2"
import script from "./re-spinner.vue?vue&type=script&lang=ts"
export * from "./re-spinner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports